import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const ResetIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M7.3.3c.4-.4,1-.4,1.4,0,.4.4.4,1,0,1.4l-1.3,1.3c3.6,0,6.6,2.9,6.6,6.5s-3,6.5-6.6,6.5c-.6,0-1-.4-1-1,0-.6.4-1,1-1,2.6,0,4.6-2,4.6-4.5s-2-4.5-4.6-4.5l1.3,1.3h0c.3.5.3,1,0,1.4-.4.4-.9.4-1.3,0h0c0,0-3.7-3.8-3.7-3.8L7.3.3Z" />
    </SvgIcon>
  );
};
